import React, { useEffect, useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { success, failure } from '~/redux/actions/snackbar-actions';
import { dispatchOrderNowByAdmin, fetchAdminOrders } from '~/redux/actions/admin-orders-actions';

// Third Party Libraries
import DatePicker from '~/components/General/OlcDatePicker';

// Utils
import { MESSAGES } from '~/utils/message';
import { dateProtector, handleRawChangeForDatePicker } from '~/utils/date-format';
import { DATE_REGEX } from '~/utils/constants';
import OlcButton from '~/components/General/OlcButton';
import OlcFormModal from '~/components/General/OlcFormModal';

// Mui Components
import { Box, CircularProgress, InputLabel } from '@mui/material';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const DispatchNowModal = (props) => {
  const { openModal, handleCloseModal, selectedOrder, getAdminOrders } = props;
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [isDatepickerOpen, setIsDatepickerOpen] = useState(false);
  const [dispatchDate] = dateRange;

  const dispatch = useDispatch();

  const onSubmit = async () => {
    try {
      setLoading(true);
      const payload = {
        orderIds: [selectedOrder],
        ...(dispatchDate && { mailDate: dispatchDate }),
      };
      const response = await dispatch(dispatchOrderNowByAdmin(payload));
      if (response.status === 200) {
        dispatch(success(response?.data?.message));
        getAdminOrders();
        handleCloseModal();
      } else {
        dispatch(failure(response?.data?.message));
      }
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || error?.message));
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  useEffect(() => {
    setDateRange([null, null]);
  }, [openModal]);

  return (
    <OlcFormModal
      open={openModal}
      onClose={handleCloseModal}
      title={MESSAGES.ADMIN_DASHBOARD.ORDERS.DISPATCH_ACTION.TITLE}
      subtitle={MESSAGES.ADMIN_DASHBOARD.ORDERS.DISPATCH_ACTION.HEADING}
      className="olcAdminFormModal"
      footer={
        <>
          <OlcButton variant="secondary" onClick={handleCloseModal}>
            {MESSAGES.ADMIN_DASHBOARD.ORDERS.DISPATCH_ACTION.CANCEL_BUTTON}
          </OlcButton>
          <OlcButton variant="primary" onClick={onSubmit} disabled={loading}>
            {loading ? (
              <CircularProgress
                sx={{
                  color: 'white',
                  width: '25px !important',
                  height: '25px !important',
                }}
              />
            ) : (
              MESSAGES.ADMIN_DASHBOARD.ORDERS.DISPATCH_ACTION.SUBMIT_BUTTON
            )}
          </OlcButton>
        </>
      }
    >
      <Box className="mailedDate">
        <Box className="selectDate">
          <InputLabel className="dateLabel">
            {MESSAGES.ADMIN_DASHBOARD.ORDERS.DISPATCH_ACTION.DISPATCH_DATE_LABEL}
          </InputLabel>
          <KeyboardArrowDownIcon
            sx={{
              color: isDatepickerOpen ? '#ED5C2F' : 'inherit',
            }}
          />
          <DatePicker
            minDate={new Date()}
            onCalendarClose={() => setIsDatepickerOpen(false)}
            selected={dispatchDate}
            onChangeRaw={(e) => {
              if (e.target.value === '' || DATE_REGEX.test(e.target.value)) {
                handleRawChangeForDatePicker(e, setDateRange);
              } else {
                e.preventDefault();
              }
            }}
            onChange={(date) => {
              dateProtector(date);
              setDateRange([date, null]);
            }}
            onFocus={() => setIsDatepickerOpen(true)}
            onBlur={(e) => {
              if (e.target.value === '') {
                setDateRange([null, null]);
              }
              setIsDatepickerOpen(false);
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText={MESSAGES.ADMIN_DASHBOARD.ORDERS.DISPATCH_ACTION.DISPATCH_DATE_LABEL}
          />
        </Box>
      </Box>
    </OlcFormModal>
  );
};

export default DispatchNowModal;
